import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { moduleService } from '../services/moduleService';
import toast from 'react-hot-toast';

export const useModules = () => {
  return useQuery(
    ['modules'],
    moduleService.getModules,
    {
      staleTime: 300000 // 5 minutes
    }
  );
};

export const useModule = (moduleId) => {
  return useQuery(
    ['module', moduleId],
    () => moduleService.getModule(moduleId),
    {
      enabled: !!moduleId,
      staleTime: 300000
    }
  );
};

export const useCreateModule = () => {
  const queryClient = useQueryClient();

  return useMutation(moduleService.createModule, {
    onSuccess: () => {
      queryClient.invalidateQueries(['modules']);
      toast.success('Module created successfully');
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || 'Failed to create module');
    }
  });
};

export const useUpdateModule = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ moduleId, data }) => moduleService.updateModule(moduleId, data),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['module', variables.moduleId]);
        queryClient.invalidateQueries(['modules']);
        toast.success('Module updated successfully');
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'Failed to update module');
      }
    }
  );
};

export const useDeleteModule = () => {
  const queryClient = useQueryClient();

  return useMutation(moduleService.deleteModule, {
    onSuccess: () => {
      queryClient.invalidateQueries(['modules']);
      toast.success('Module deleted successfully');
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || 'Failed to delete module');
    }
  });
};